/**
 * 默认面包屑路径
 */
export const getDefaultBreadcrumbItems = (serviceName?: string) => [
  { title: '首页' },
  { title: '身份证明局(DSI)' },
  { title: 'Demo事项' },
];

/**
 * 申請步驟類型
 */
export enum StepType {
  note = '1',
  form = '2',
  dataCheck = '3',
  faceRecognition = '4',
  payment = '5',
  upload = '6',
}

export enum securityLevel {
  SATISFACTORY = 1,
  HIGH = 2,
  VERY_HIGH = 3,
}

/**
 * 申請步驟
 */
export const stepInfo = [
  {
    stepType: StepType.form,
    stepName: '申请资料',
  },
  {
    stepType: StepType.dataCheck,
    stepName: '资料确认',
  },
  {
    stepType: StepType.faceRecognition,
    stepName: '身份识别',
  },
  {
    stepType: StepType.payment,
    stepName: '支付信息',
  },
];
